import config from '../../../config';
import { SpriteToRect, debounce } from '../../../utils';
import { getStepPos } from '../tools';

let soundManager;

function initElectricGates (layer) {
  let g = this.g;
  let hazzards = [];
  let highlights = [];

  soundManager = g.scene.get('SoundManager');

  let startFrame = g.anims.get('wall-charge-single').frames[0].frame.name;

  _.each(layer.groups.tiles, (sprite) => {
    let direction = parseFrameName(sprite.frame.name);
    sprite.setVisible(false);
    sprite.setActive(false);
    let wall = g.add.sprite(sprite.x, sprite.y, 'wall-charge');
    wall.setScale(0.5);
    wall.resetY = sprite.resetY;
    wall.angle = getAnimationRotation(direction);
    wall.setFrame(startFrame);
    highlights.push(wall);
    sprite.highlight = wall;

    if (sprite.claimed) { return; }

    let zap;
    switch (direction) {
      case config.RIGHT:
        zap = g.add.sprite(sprite.x, sprite.y, 'zap');
        zap.setScale(0.5);
        break;
      case config.DOWN:
        zap = g.add.sprite(sprite.x, sprite.y, 'zap');
        zap.angle = 90;
        zap.setScale(0.5);
        break;
    }

    if (!zap) { return; }

    zap.emitter = sprite;
    // calc reviever
    let rayCasting = true;
    let step = 0;
    let reciever = null;
    let stepPos = null;

    while (rayCasting) {
      step++;
      stepPos = getStepPos(direction, zap.x, zap.y, step);
      reciever = this.checkLayerTiles(stepPos, layer);
      if (reciever) {
        rayCasting = false;
      }
    }

    if (reciever === -1 || reciever.claimed) {
      zap.reciever = null;
      console.warn('null reciever');
    } else {
      reciever.claimed = true;
      zap.reciever = reciever;
      zap.steps = step;
      zap.setPosition(reciever.x, reciever.y);
    }

    zap.setAlpha(0);
    hazzards.push(zap);
  });

  _.each(hazzards, (zap) => {
    g.children.bringToTop(zap.emitter.highlight);
    g.children.bringToTop(zap.reciever.highlight);
  });

  layer.groups.hazzards = hazzards;
  layer.groups.highlights = highlights;

  cycleElectricGates.call(this, hazzards);
}

let checkForPlaySound = debounce(function (g, sprite) {
  let cameraRect = new Phaser.Geom.Rectangle(0, g.cameras.main.scrollY, config.WIDTH, config.HEIGHT);
  let spriteRect = SpriteToRect(sprite);
  // console.log(cameraRect, spriteRect);
  if (Phaser.Geom.Intersects.RectangleToRectangle(cameraRect, spriteRect)) {
    soundManager.playSound('electric-fence');
  }
}, 250, true);

function cycleElectricGates (hazzards) {
  let g = this.g;

  _.each(hazzards, (zap) => {
    if (!zap.reciever) { return; }

    let emitter = zap.emitter;
    let reciever = zap.reciever;

    zap.setPosition(emitter.x, emitter.y);
    zap.play('wall-zap');
    zap.location = 'emitter';

    zap.tween = g.add.tween({
      targets: zap,
      x: reciever.x,
      y: reciever.y,
      duration: zap.steps * config.ELECTRIC_GATE_SPEED,
      delay: config.ELECTRIC_GATE_CHARGE,
      repeatDelay: config.ELECTRIC_GATE_CHARGE,
      hold: config.ELECTRIC_GATE_CHARGE,
      yoyo: true,
      repeat: -1,
      onUpdate: () => {
        let onEmitter = zap.x === emitter.x && zap.y === emitter.y;
        let onReciever = zap.x === reciever.x && zap.y === reciever.y;
        if (onEmitter || onReciever) {
          zap.setAlpha(0);
        } else {
          zap.setAlpha(1);
        }
        if (zap.location === 'emitter' && onReciever) {
          // console.log('switch to reciever');
          zap.location = 'reciever';
          reciever.highlight.play('wall-charge-single');
          checkForPlaySound(g, reciever);
        }
        if (zap.location === 'reciever' && onEmitter) {
          // console.log('switch to emitter');
          zap.location = 'emitter';
          emitter.highlight.play('wall-charge-single');
          checkForPlaySound(g, emitter);
        }
      },
      onStart: () => {
        emitter.highlight.play('wall-charge-single');
      }
    });
  });
}

function parseFrameName (name) {
  return name.split('-').pop().replace('.png', '');
}

function getAnimationRotation (direction) {
  let degrees = 0;
  switch (direction) {
    case config.DOWN:
      degrees = 90;
      break;
    case config.LEFT:
      degrees = 180;
      break;
    case config.UP:
      degrees = 270;
      break;
  }
  return degrees;
}

export {
  initElectricGates,
  cycleElectricGates
};
